// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf, anyOf, is } from "@altostra/type-validations";
import { boolean, number, string } from "@altostra/type-validations/lib/primitives";

export const isGetDecisioningStudioAgentsAppGroupIdResult = objectOf({
  hits: number,
  results: arrayOf(
    objectOf({
      id: string,
      of_client_slug: string,
      of_pipeline_slug: string,
      of_usecase_slug: string,
    })
  ),
});

export const isPostDecisioningStudioAgentsAppGroupIdResult = objectOf({
  id: string,
  of_client_slug: string,
  of_pipeline_slug: string,
  of_usecase_slug: string,
  frequency_cap: boolean,
  exclude_from_global_frequency_count: boolean,
});

// `display_name` is null when the conflicting agent predates display names.
export const isPostDecisioningStudioAgentsAppGroupIdNameTakenMeta = objectOf({
  display_name: anyOf(string, is(null)),
});
